import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

// Scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease: easing, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Staggered container
export const StaggerGroup = ({ children, className = "", stagger = 0.12 }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ visible: { transition: { staggerChildren: stagger } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: easing } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (signature on-load hero moment)
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: easing, delay }}
    >
      {children}
    </motion.span>
  </span>
);
